"use client";
import React from "react";
import { renderIcon } from "@/lib/icon";
import type { FeatureSection } from "@/components/features";
import { getBackgroundStyle } from "@/lib/background";
import Image from "next/image";

export default function FeaturesIconLeft({ data }: FeatureSection) {
  const { title, subtitle, features = [], background } = data || {};

  const bgStyle = getBackgroundStyle(background);

  return (
    <section className="py-20 px-4 relative" style={bgStyle}>
      {background?.type === "image" && background?.value && (
        <Image
          src={background.value}
          alt={title || subtitle || ""}
          fill
          priority
          className="object-cover object-center z-0"
        />
      )}
      <div className="max-w-6xl mx-auto relative z-10">
        {title && (
          <h2 className="text-3xl font-bold mb-4 text-left text-foreground">
            {title}
          </h2>
        )}
        {subtitle && (
          <p className="text-muted-foreground mb-8 text-left">{subtitle}</p>
        )}

        <div className="space-y-6">
          {features.map((item, idx) => (
            <div key={idx} className="flex gap-4 items-start">
              <div className="text-3xl">{renderIcon({ icon: item.icon })}</div>
              <div>
                <h3 className="text-lg font-semibold">{item.title}</h3>
                <p className="text-muted-foreground">{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
